import React from "react";
import variables from "../styleVariables";

const TrendUpIcon = ({ color = variables.colorSuccess }) => (
  <svg viewBox="0 0 24 24" className="trend-icon">
    <path fill={color} d="M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z" />
  </svg>
);

export default TrendUpIcon;
